module.exports = __webpack_public_path__ + "static/img/5.67057dd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/2/eng/5.png
// module id = jUZm
// module chunks = 0